// `_identity` : an utility's function
// ------------------------------------

// Keep the identity function around for default iteratees.
export default function (value) {
	return value;
}